// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3Ftic","imageUploader":"EGiftCard_imageUploader__2IcQ6"};